import React from 'react'

const UserTotalExpenses = ({ expenses, user }) => {
  let user_expenses = 0;
  expenses.filter(expense => (expense.spent_by === user.guid)).forEach(expense => {
    user_expenses += parseFloat(expense.amount);
  })
  return (
    <div className="row">
      <div className="column">{user.f_name} {user.l_name}</div>
      <div className="column align-right">{user_expenses}</div>
      {/* <div className="column align-right">
            <span className="intent-success">+783.33</span>
        </div> */}
    </div>
  )
}
export default UserTotalExpenses;